import { fetchApi } from "../../config/fetchConfig";
import I18n from "../../I18n";
import { pushDialog } from "./dialogActions";

export const getColbiDdEntities = (fileType) => (dispatch, getState) => {
    const queriesBody = {
        query: `query($f:String!){get_colbi_dd_entities_from_file_type(fileType:$f){id, name}}`,
        variables: {
            f: `${fileType}`
        },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            const data = res.data["get_colbi_dd_entities_from_file_type"] || [];
            return data;
        })
        .catch((e) => {
            dispatch(
                pushDialog("AlertDialog", I18n.translate`Request Error`, {
                    title: I18n.translate`Somethings went wrong getting get_colbi_dd_entities`,
                }),
            );
        });
};